import React from 'react'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import DecoupledDocumentEditor from 'ckeditor5-custom-build/build/ckeditor'
import { replaceBeforeEscape } from 'utils/common-util'

// css
import 'assets/style/elements/text.scss'
import 'assets/css/dev.css'

function Element({ className = '', text, style = {}, isFull = false, isEscape = true }) {
  if (isFull) {
    style.minHeight = '60vh'
  }
  return (
    <>
      <span className={'common-text ' + className} style={style}>
        <CKEditor
          editor={DecoupledDocumentEditor}
          data={isEscape ? replaceBeforeEscape(text) : text}
          disabled={true}
          config={{
            toolbar: [],
            link: {
              decorators: {
                addTargetToExternalLinks: {
                  mode: 'automatic',
                  callback: (url) => /^(https?:)?\/\//.test(url),
                  attributes: {
                    target: '_blank',
                    rel: 'noopener noreferrer',
                  },
                },
              },
            },
          }}
        />
      </span>
    </>
  )
}

export default Element
